/* Redesign interactions — brand tabs, in-panel paging, FAQ accordion.
   Vanilla, no jQuery, no carousel library. Deferred; nothing here runs before
   first paint and nothing here can shift layout.

   Progressive enhancement: without JS, the first tab panel and the first page
   of products are visible and every link still works. The accordion bodies are
   opened by removing [hidden], so a no-JS visitor sees closed rows — same as
   the live Bootstrap accordion behaves today. */
(function () {
  'use strict';

  /* ------------------------------------------------------------ money ----
     ONE MONEY CONTRACT for every script on the page (docs/MULTI-CURRENCY.md
     §4.1). Defined first, before anything else in this file can throw, because
     redesign-pdp.js, redesign-predictive.js, redesign-promo.js, the inline
     free-shipping bar and purchase-options.js all format through it.

     Nothing here knows a symbol, a separator or a decimal count. The layout
     emits <meta name="rd-money"> carrying 1234567.89 formatted by Shopify for
     THIS session (money and money_with_currency), and the shape is read off
     that sample: prefix and suffix are whatever sits either side of the
     digits, the decimal separator is the character before the last two digits
     (when the digits say there are decimals at all), the group separator is
     what splits the integer part and the group sizes are its runs. So a
     shopper in any presentment currency gets exactly the shape Liquid prints
     on the same page. The JS only ever has to MATCH the server, never decide.

     Missing or unreadable meta: the shape falls back to exactly what every
     script did before this existed — "$", en-US grouping, two decimals — so a
     broken emitter degrades to the current site, never to blank prices.

     D3 (§1): a TOTAL outside the store currency carries the code — "$45.99
     CAD" — because CAD, AUD and SGD all print a bare "$". format(c, {withCode:
     true}) applies it, and only when the session currency is not the shop's;
     in USD it is the bare figure, byte for byte. snippets/redesign-money.liquid
     is the Liquid half of the same rule. */
  window.rdMoney = (function () {
    var FALLBACK = { pre: '$', suf: '', preW: '$', sufW: '', dec: '.', group: ',', places: 2, g1: 3, g2: 3 };

    /* The sample travels through an attribute, so an entity-style format
       ("&euro;{{amount}}") arrives either decoded or, after | escape, once
       encoded. Decoding here makes both the literal character. */
    function decode(s) {
      if (!s || s.indexOf('&') === -1) return s;
      var t = document.createElement('textarea');
      t.innerHTML = s;
      return t.value;
    }

    /* Reads one Shopify-formatted 1234567.89. Returns null if it cannot be
       read with certainty — the caller then keeps the fallback shape. */
    function read(sample) {
      if (!sample) return null;
      var first = sample.search(/\d/);
      if (first === -1) return null;
      var last = sample.length - 1;
      while (last > first && !/\d/.test(sample.charAt(last))) last--;
      var num = sample.slice(first, last + 1);
      var digits = num.replace(/\D/g, '');
      var places;
      if (digits === '123456789') places = 2;        /* {{amount}} and its separator variants */
      else if (digits === '1234568') places = 0;     /* the _no_decimals formats round */
      else return null;
      var intPart = num, dec = '';
      if (places) {
        dec = num.charAt(num.length - places - 1);
        if (/\d/.test(dec)) return null;
        intPart = num.slice(0, num.length - places - 1);
      }
      var seps = intPart.match(/\D+/g) || [];
      for (var i = 1; i < seps.length; i++) if (seps[i] !== seps[0]) return null;
      var runs = intPart.split(/\D+/);
      var g1 = runs[runs.length - 1].length;
      return {
        pre: sample.slice(0, first), suf: sample.slice(last + 1),
        dec: dec, group: seps[0] || '', places: places,
        /* Primary and secondary group sizes, so lakh grouping (12,34,567)
           would come out right as well as the usual threes. */
        g1: g1, g2: runs.length > 2 ? runs[runs.length - 2].length : g1,
        num: num
      };
    }

    var meta = document.querySelector('meta[name="rd-money"]');
    var S = FALLBACK, fromMeta = false;
    var shopCurrency = (meta && meta.getAttribute('data-shop-currency')) || 'USD';
    var sc = window.Shopify && window.Shopify.currency;
    var currency = (meta && meta.getAttribute('data-currency')) || (sc && sc.active) || shopCurrency;
    if (meta) {
      var bare = read(decode(meta.getAttribute('data-sample')));
      if (bare && bare.g1 > 0) {
        S = bare;
        fromMeta = true;
        /* The with-code sample must be the same number in the same shape;
           only its prefix and suffix are taken from it. */
        var wc = read(decode(meta.getAttribute('data-with-code')));
        if (wc && wc.num === bare.num) { S.preW = wc.pre; S.sufW = wc.suf; }
        else { S.preW = bare.pre; S.sufW = bare.suf + ' ' + currency; }
      }
    }

    var rate = sc ? parseFloat(sc.rate) : NaN;
    var rateKnown = isFinite(rate) && rate > 0;
    if (!rateKnown) rate = 1;
    var foreign = currency !== shopCurrency;

    function group(intStr) {
      if (!S.group || intStr.length <= S.g1) return intStr;
      var out = intStr.slice(-S.g1), rest = intStr.slice(0, -S.g1);
      while (rest.length > S.g2) {
        out = rest.slice(-S.g2) + S.group + out;
        rest = rest.slice(0, -S.g2);
      }
      return rest + S.group + out;
    }

    /* The pieces every output is built from, so format and formatHTML cannot
       disagree about anything but the span. */
    function pieces(cents, opts) {
      var n = Math.round(Number(cents));
      if (!isFinite(n)) return null;
      opts = opts || {};
      var abs = Math.abs(n), whole, frac = '';
      if (S.places) {
        whole = String(Math.floor(abs / 100));
        frac = String(abs % 100);
        if (frac.length < 2) frac = '0' + frac;
        /* Liquid's `| remove: '<sep>00'` and money_without_trailing_zeros:
           a whole amount loses its decimals. */
        if (opts.trailingZeros === false && frac === '00') frac = '';
      } else {
        whole = String(Math.round(abs / 100));
      }
      var code = !!opts.withCode && foreign;
      return {
        sign: n < 0 ? '-' : '',
        pre: code ? S.preW : S.pre,
        suf: code ? S.sufW : S.suf,
        int: group(whole),
        frac: frac ? S.dec + frac : ''
      };
    }

    /* format(cents, {trailingZeros, withCode}) -> text, for textContent.
       Defaults match Liquid's `| money`: decimals kept, no code. */
    function format(cents, opts) {
      var p = pieces(cents, opts);
      return p ? p.sign + p.pre + p.int + p.frac + p.suf : '';
    }

    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    /* formatHTML(cents, {withCode, trailingZeros}) -> the markup
       snippets/redesign-money.liquid prints: decimals in .rd-cents, whole
       amounts stripped (its default, so trailingZeros defaults to false here).
       Byte for byte the same in the store currency; the cart tween writes
       this over the server's figure every frame, so any difference is a
       reflow mid-count. */
    function formatHTML(cents, opts) {
      opts = opts || {};
      var p = pieces(cents, { withCode: opts.withCode, trailingZeros: opts.trailingZeros === true });
      if (!p) return '';
      return esc(p.sign + p.pre + p.int) +
        (p.frac ? '<span class="rd-cents">' + esc(p.frac) + '</span>' : '') + esc(p.suf);
    }

    /* parse(text) -> cents, the inverse of format with the detected
       separators; the cart's readCents. The number is taken from the first
       digit to the last, so a prefix like "Rs." or a " CAD" suffix never
       counts, and only the LAST decimal separator splits off the cents. */
    function parse(text) {
      if (text == null) return null;
      var t = String(text);
      var first = t.search(/\d/);
      if (first === -1) return null;
      var last = t.length - 1;
      while (last > first && !/\d/.test(t.charAt(last))) last--;
      var num = t.slice(first, last + 1);
      var whole = num, frac = '';
      if (S.places && S.dec) {
        var at = num.lastIndexOf(S.dec);
        if (at !== -1) { whole = num.slice(0, at); frac = num.slice(at + 1).replace(/\D/g, ''); }
      }
      whole = whole.replace(/\D/g, '');
      var cents = parseInt(whole || '0', 10) * 100;
      if (frac) cents += Math.round(parseInt(frac, 10) * Math.pow(10, 2 - frac.length));
      if (/[-−]/.test(t.slice(0, first))) cents = -cents;
      return isFinite(cents) ? cents : null;
    }

    /* Does this server-rendered figure carry the D3 currency code? Lets a
       script that rewrites a figure keep whatever shape the server chose for
       it (the cart tween does), rather than knowing which figures are totals. */
    function hasCode(text) {
      if (!foreign || text == null) return false;
      var t = String(text).trim();
      var sw = S.sufW.trim(), pw = S.preW.trim();
      if (sw && sw !== S.suf.trim()) return t.slice(-sw.length) === sw;
      if (pw && pw !== S.pre.trim()) return t.slice(0, pw.length) === pw;
      return false;
    }

    /* fromShop(usdCents) -> presentment cents, for STORE-CURRENCY CONSTANTS
       only (the free-shipping threshold). Shopify converts the same condition
       at checkout at this rate. null when the session is in another currency
       and the rate is unknown: callers must not compare then (D4c). */
    function fromShop(usdCents) {
      var n = Number(usdCents);
      if (!isFinite(n)) return null;
      if (!foreign) return Math.round(n);
      return rateKnown ? Math.round(n * rate) : null;
    }

    return {
      currency: currency,
      shopCurrency: shopCurrency,
      rate: rate,
      rateKnown: rateKnown,
      fromMeta: fromMeta,
      format: format,
      formatHTML: formatHTML,
      parse: parse,
      hasCode: hasCode,
      fromShop: fromShop
    };
  })();
  var rdMoney = window.rdMoney;

  /* Free-shipping figures in copy (snippets/rd-fs-goal.liquid — "free express
     air shipping over $190"). Outside the store currency the server prints
     "US$190" with the dollar cents on data-rd-fs-usd, and this writes the
     converted figure over it: the same conversion the cart bar and the PDP
     meter use, whole amounts without ".00". No rate, no change. The meter and
     the bar carry data-rd-fs-usd too but not data-rd-fs-goal; they paint
     their own figures. */
  document.querySelectorAll('[data-rd-fs-goal][data-rd-fs-usd]').forEach(function (el) {
    var local = rdMoney.fromShop(parseInt(el.getAttribute('data-rd-fs-usd'), 10));
    if (local !== null) el.textContent = rdMoney.format(local, { trailingZeros: false });
  });

  /* ---------------------------------------------------------- brand tabs */
  document.querySelectorAll('[role="tablist"]').forEach(function (list) {
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function panelFor(tab) {
      return document.getElementById(tab.getAttribute('aria-controls'));
    }

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = panelFor(t);
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
      var active = panelFor(tab);
      if (active) showPage(active, 0);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(tab);
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });

    /* ------------------------------------------------------ in-panel paging */
    /* The prev/next buttons sit beside the tablist in .rd-tabs-bar, not inside
       it: a tablist may only contain tabs (Lighthouse aria-required-children,
       11 Sep 2026). Look in the bar, falling back to the list itself. */
    var bar = list.closest('.rd-tabs-bar') || list;
    var nav = bar.querySelector('[data-rd-page="prev"]');
    var navNext = bar.querySelector('[data-rd-page="next"]');

    function activePanel() {
      var on = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
      return on ? panelFor(on) : null;
    }

    function pageCount(panel) {
      var cards = panel.querySelectorAll('[data-rd-page-index]');
      var max = 0;
      cards.forEach(function (c) {
        max = Math.max(max, parseInt(c.getAttribute('data-rd-page-index'), 10) || 0);
      });
      return max + 1;
    }

    /* `animate` is false for the very first call: the server already rendered
       page 0, the browser has already painted those cards, and replaying the
       staggered entrance over them reads as the whole grid flashing and
       reloading a beat after the page settles. Tab and page changes do want
       it -- there the cards genuinely are new. */
    function showPage(panel, page, animate) {
      if (!panel) return;
      var total = pageCount(panel);
      var p = ((page % total) + total) % total;
      panel.setAttribute('data-rd-current-page', String(p));
      var shown = 0;
      panel.querySelectorAll('[data-rd-page-index]').forEach(function (card) {
        var visible = (parseInt(card.getAttribute('data-rd-page-index'), 10) || 0) === p;
        card.hidden = !visible;
        /* Stagger the entrance so a page or brand change eases in rather than
           snapping. Class is removed first so it replays on every change. */
        card.classList.remove('is-entering');
        if (visible) {
          card.style.setProperty('--rd-i', shown++);
          if (animate !== false) {
            void card.offsetWidth;
            card.classList.add('is-entering');
          }
        }
      });
      if (nav && navNext) {
        var single = total <= 1;
        nav.disabled = single;
        navNext.disabled = single;
      }
    }

    function step(delta) {
      var panel = activePanel();
      if (!panel) return;
      var cur = parseInt(panel.getAttribute('data-rd-current-page'), 10) || 0;
      showPage(panel, cur + delta);
    }

    if (nav) nav.addEventListener('click', function () { step(-1); });
    if (navNext) navNext.addEventListener('click', function () { step(1); });

    var first = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    var firstPanel = panelFor(first);
    if (firstPanel) showPage(firstPanel, 0, false);
  });

  /* ------------------------------------------------------ video tiles */
  /* Each tile ships as a poster image plus a button; the <video> waits inside an
     inert <template>. The tap below is what creates the element, so it is also
     what issues the very first network request for the file. */
  (function () {
    /* Queried live rather than kept in a registry: players are cloned in on
       demand, so the DOM is the only list that is never out of date. */
    function running(except) {
      var out = [];
      document.querySelectorAll('[data-rd-video] video').forEach(function (m) {
        if (m !== except && !m.paused) out.push(m);
      });
      return out;
    }

    function pauseOthers(except) {
      running(except).forEach(function (m) { m.pause(); });
    }

    /* The class follows the element's real state rather than being toggled by
       hand, so a stall or a decode failure cannot leave the disc hidden over a
       video that is not running. Takes the tile explicitly so callers outside
       this loop — see window.rdVideo below — get the same wiring. */
    function watch(tile, play, media) {
      var label = (play && play.getAttribute('aria-label')) || '';
      media.addEventListener('play', function () {
        tile.classList.remove('is-ended');
        tile.classList.add('is-playing');
        if (play) play.setAttribute('aria-label', 'Pause ' + label);
        pauseOthers(media);
      });
      media.addEventListener('pause', function () {
        tile.classList.remove('is-playing');
        if (play) play.setAttribute('aria-label', 'Play ' + label);
      });
      media.addEventListener('ended', function () {
        /* The poster comes back on its own now: the stylesheet shows the
           player only while `is-playing` is set, so pausing reveals it too —
           which is what live does. What is particular to ENDING is the rewind:
           without it the next tap would resume on the last frame. Frame 0 is
           often not the frame the poster was chosen to be, which is why the
           rewind happens while the player is already hidden.

           The spec fires pause before ended, so is-playing is already gone by
           now; dropping it here as well covers browsers that skip that.
           `is-ended` no longer drives any style and is kept as a state hook. */
        media.currentTime = 0;
        tile.classList.remove('is-playing');
        tile.classList.add('is-ended');
      });
    }

    /* Build the player if it is still in its <template>, wire it, and start it.
       MUST be called synchronously from a click handler — iOS drops the user
       activation otherwise. Returns false only when the tile has no player at
       all, so callers can tell a video tile from a plain image. */
    function startTile(tile) {
      if (!tile) return false;
      var play = tile.querySelector('[data-rd-video-play]');
      var tpl = tile.querySelector('template[data-rd-video-src]');
      var media = tile.querySelector('video');

      /* Second tap while running: pause, which brings back both the disc and
         the poster, and keeps the position for the next tap. */
      if (media && !media.paused) { media.pause(); return true; }

      var justAdded = false;
      if (!media && tpl) {
        /* Appended last so it paints above the poster. The button stays on top
           of it and keeps its clicks — there are no native controls underneath
           to reach, and it is what pauses. */
        tile.appendChild(tpl.content.cloneNode(true));
        media = tile.querySelector('video');
        if (media) {
          watch(tile, play, media);
          justAdded = true;
          /* A player whose file is given as <source> children has not chosen one
             yet at this point, and play() called before that finishes is aborted
             mid-selection — the tap is swallowed and the tile just sits there.
             load() starts selection now so the play below has a candidate.
             Nothing to do when the src is on the element itself, which is how
             both the homepage blocks and the PDP tiles render it; this covers a
             video_tag block, which emits children. */
          if (media.querySelector('source')) media.load();
        }
      }
      if (!media) return false;

      /* Give up on a player and put the poster back, rather than leaving a dead
         black tile. Only for a genuine refusal — see below. */
      function abandon(err) {
        console.error('Video play failed:', err);
        tile.classList.remove('is-playing');
        if (justAdded && media.parentNode) media.parentNode.removeChild(media);
      }

      var p = media.play();
      if (p && p.catch) {
        p.catch(function (err) {
          /* THIS USED TO ABANDON THE PLAYER ON ANY REJECTION, AND THAT COST THE
             FIRST TAP. play() is called in the same tick the player is cloned
             in, so it is racing the load; when the browser interrupts that it
             rejects with AbortError, the player was torn out, and only the
             SECOND tap — cloning again against a warm cache — actually played.

             An AbortError is not a refusal, it is an interruption: permission
             was already granted by the tap that got us here. So the player is
             kept and play is retried the moment there is something to play.
             NotAllowedError is the real refusal and still abandons immediately;
             so does a retry that fails, which covers an unsupported file. */
          if (!err || err.name === 'NotAllowedError') return abandon(err);

          function retry() {
            media.removeEventListener('canplay', retry);
            var q = media.play();
            if (q && q.catch) q.catch(abandon);
          }
          /* canplay may already have fired while the rejection was settling. */
          if (media.readyState >= 3) retry();
          else media.addEventListener('canplay', retry);
        });
      }
      return true;
    }

    /* Exposed the same way the cart drawer is. redesign-pdp.js was cloning the
       template and calling play() itself, which skipped watch() entirely: the
       is-playing class was then set by hand and never driven by the media, so
       the disc stayed over a running video. Nothing outside this file should
       build a player. */
    window.rdVideo = { play: startTile };

    document.querySelectorAll('[data-rd-video]').forEach(function (tile) {
      var play = tile.querySelector('[data-rd-video-play]');
      if (!play) return;

      /* A tile whose video was rendered inline rather than into a template still
         works — nothing here assumes the facade. */
      var inline = tile.querySelector('video');
      if (inline) watch(tile, play, inline);

      play.addEventListener('click', function () { startTile(tile); });
    });

    /* A press anywhere that is not the playing tile stops it. Bound once on the
       document rather than per tile, so it also covers the header, the footer
       and anything rendered after this ran.

       A tap on a tile's own button reaches here too, having already started or
       stopped that video — the containment check is what leaves it alone. */
    document.addEventListener('click', function (e) {
      var host = e.target && e.target.closest ? e.target.closest('[data-rd-video]') : null;
      running(null).forEach(function (m) {
        if (host && host.contains(m)) return;
        m.pause();
      });
    });
  })();

  /* ------------------------------------------------ scroll-restore hold */
  /* THE DECISION IS MADE IN THE HEAD, NOT HERE. layout/theme.liquid carries a
     small synchronous script that adds .rd-chrome-hold before the trust bar is
     even parsed. It cannot live in this file: redesign.js is deferred, and a
     deferred script does not beat first paint. Measured in Chromium on 10 Sep
     2026 — the bar painted forest green at t=5ms and this file did not run
     until t=6ms, so every hold it added was a frame late and the green strip
     was seen anyway. That is what Sam reported.

     The previous version could not have worked for a second reason: it asked
     window.scrollY whether the page was about to be restored to a scrolled
     position, and returned early when it read 0. The restore had not happened
     yet, so it read 0 in exactly the case it was written for.

     What is left here is the two halves that do not need to be early. */
  (function () {
    var root = document.documentElement;

    /* No bar on this page (the cart suppresses it) — drop the class rather than
       leaving it on <html> for rules that do not exist yet. */
    if (!document.querySelector('.rd-trust')) {
      root.classList.remove('rd-chrome-hold');
      return;
    }

    /* HALF ONE: remember where this page was left, so the head script knows a
       scrolled restore is coming next time. pagehide covers a reload and a
       same-tab navigation; visibilitychange covers the phone, where a tab can
       be discarded without either unload event firing. */
    var KEY = 'rd-sy:' + location.pathname + location.search;
    function remember() {
      try { sessionStorage.setItem(KEY, String(Math.round(window.scrollY))); } catch (e) {}
    }
    window.addEventListener('pagehide', remember);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') remember();
    });

    if (!root.classList.contains('rd-chrome-hold')) return;

    /* HALF TWO: put the page where it belongs, then show it.

       The first version of this waited for the browser to restore the scroll
       position and revealed the page when it did. That is the part Sam kept
       seeing fail — "it starts with the page being high up and the product
       image showing for a moment, then it scrolls downwards" — because the wait
       has to have a deadline, and any deadline is sometimes shorter than the
       browser takes. Measured on this storefront the restore landed anywhere
       between 78ms and 367ms, and on a real phone it can be later still.

       So stop waiting. The saved position is already known — it is what the
       head script read to decide to hold at all — and by the time this deferred
       script runs the document has been parsed and every image carries explicit
       dimensions, so the page is already its full height. Scroll there, then
       reveal. No deadline to get wrong, and nothing to detect.

       The browser's own restoration is left switched on rather than disabled:
       it targets the same offset, a script scroll cancels it, and if this file
       never arrives it is still the thing that puts the visitor back. */
    var target = 0;
    try { target = parseInt(sessionStorage.getItem(KEY) || '0', 10) || 0; } catch (e) {}

    var released = false;
    function release() {
      if (released) return;
      released = true;
      /* NO FADE. redesign-base.css line 432 gives body `transition: opacity
         1.2s ease-out`, inherited from the legacy theme, so simply dropping the
         class cross-faded the entire page in over more than a second — Sam:
         "dont do any fadein for the whole page loading, it feels akward".

         The transition cannot be cancelled from the held rule, because a
         transition is computed from the style the element is changing TO, and
         by then the class is gone. It has to be suppressed inline across the
         change and handed back afterwards. */
      var b = document.body;
      var keep = b.style.transition;
      b.style.transition = 'none';
      root.classList.remove('rd-chrome-hold');
      void b.offsetHeight;                 /* commit the new opacity untransitioned */
      b.style.transition = keep;
      window.removeEventListener('wheel', release);
      window.removeEventListener('touchstart', release);
      window.removeEventListener('keydown', release);
    }
    /* Someone who touches the page while it is held is driving it now. */
    window.addEventListener('wheel', release, { passive: true });
    window.addEventListener('touchstart', release, { passive: true });
    window.addEventListener('keydown', release);

    /* NOT window.scrollTo ALONE. redesign-base.css line 446 sets
       `scroll-behavior: smooth` on html and body, so a programmatic scroll
       ANIMATES — which is the page Sam watched "scroll downwards" after the
       reveal instead of simply being there. Suppressed inline for the one call
       and handed straight back, so smooth scrolling still works everywhere it
       is wanted. Both elements, because engines disagree about which one owns
       the viewport's behaviour. */
    function jump(y) {
      var de = document.documentElement, b = document.body;
      var a = de.style.scrollBehavior, c = b.style.scrollBehavior;
      de.style.scrollBehavior = 'auto';
      b.style.scrollBehavior = 'auto';
      window.scrollTo(0, y);
      de.style.scrollBehavior = a;
      b.style.scrollBehavior = c;
    }

    /* WAIT FOR THE PAGE TO HAVE A HEIGHT, then place it. This script is
       deferred so the document is fully parsed, but the stylesheets may not
       have applied yet and without layout scrollHeight is 0 — measured on the
       live PDP, one reload reported no height at all until 341ms while another
       was at full height by 87ms. Scrolling during that window would clamp to
       0 and reveal the top, which is the whole fault being fixed.

       So the loop is bounded by the deadline below rather than by a frame
       count, and the deadline places the page as far as it can reach before
       revealing it. Either way the visitor is never shown the top. */
    function finish() {
      if (released) return;
      var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      var y = Math.min(target, max);
      if (Math.abs(window.scrollY - y) > 1) jump(y);
      release();
    }
    (function place() {
      if (released) return;
      if (document.documentElement.scrollHeight - window.innerHeight >= target) return finish();
      requestAnimationFrame(place);
    })();

    /* Belt and braces. A hidden page is the failure that must not be reachable,
       and the CSS carries a second, independent reveal at 900ms besides. */
    setTimeout(finish, 700);
  })();

  /* ------------------------------------------ mobile peek carousel dots */
  /* Built from the real card count rather than rendered in Liquid, because the
     desktop paging and the mobile swipe disagree about how many "pages" exist —
     on mobile every card is reachable, on desktop they are grouped five at a
     time. Only wired up at mobile widths; the dots are display:none elsewhere. */
  (function () {
    var mq = window.matchMedia('(max-width: 900px)');
    var tracks = document.querySelectorAll('.rd-swipe');
    /* A row filled after load (the product page's recently viewed strip,
       assets/redesign-pdp.js) asks for its dots here. Defined before the
       early return, so it exists on a page whose only row arrives later. */
    window.rdSwipeDots = function (track) { if (mq.matches) build(track); };
    if (!tracks.length) return;

    function build(track) {
      if (track.nextElementSibling && track.nextElementSibling.classList.contains('rd-dots')) return;
      /* Direct children, so this works for product cards, video tiles and the
         parent-approved cards alike. */
      var cards = track.children;
      if (cards.length < 2) return;
      cards = Array.prototype.slice.call(cards);

      var dots = document.createElement('div');
      dots.className = 'rd-dots';
      cards.forEach(function (card, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to item ' + (i + 1));
        b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        if (i === 0) b.classList.add('is-active');
        b.addEventListener('click', function () {
          track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });
      track.parentNode.insertBefore(dots, track.nextSibling);

      /* The active dot is the card crossing the track's centre line. The
         observer's root is the track pulled in to a 2% band at its middle, so
         a card intersects exactly while it spans the centre.

         This used to be measured: scrollLeft, clientWidth and every card's
         offsetLeft/offsetWidth, on load and on each scroll frame. Whenever
         anything else had changed the page first, those reads forced a layout
         (PageSpeed "Forced reflow": 41ms on 11 Sep 2026, still 34ms on 12 Sep
         after deferring them a frame). An observer reads nothing, so it cannot.
         While the band sits in the gap between two cards the last one keeps the
         dot; with 300px cards it switches within 2px of where the old code did.

         The first dot starts active, as the old code left it: a track inside a
         hidden tab panel has no layout, so the observer reports nothing for it
         until the panel is shown. */
      if (!('IntersectionObserver' in window)) return;
      var buttons = dots.children;
      var active = 0;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var i = cards.indexOf(entry.target);
          if (i < 0 || i === active) return;
          buttons[active].classList.remove('is-active');
          buttons[active].setAttribute('aria-current', 'false');
          buttons[i].classList.add('is-active');
          buttons[i].setAttribute('aria-current', 'true');
          active = i;
        });
      }, { root: track, rootMargin: '0px -49% 0px -49%' });
      cards.forEach(function (card) { io.observe(card); });
    }

    function apply() {
      if (!mq.matches) return;
      tracks.forEach(build);
    }
    apply();
    mq.addEventListener('change', apply);
  })();

  /* --------------------------------------------- restore smooth scrolling */
  /* Scroll restoration must not animate (see the note in redesign.css), so
     scroll-behavior starts at auto. Re-enable smooth once the load has settled,
     so anchor links still glide. */
  (function () {
    function enable() { document.documentElement.classList.add('rd-smooth-ready'); }
    if (document.readyState === 'complete') setTimeout(enable, 60);
    else window.addEventListener('load', function () { setTimeout(enable, 60); }, { once: true });
  })();

  /* ------------------------------------------------------ image fade-in */
  /* Opt in from JS so a no-JS visitor never gets invisible images: the CSS only
     hides an unloaded image once .rd-fade-ready is present. Images already in
     the cache report complete synchronously and are marked immediately, so
     cached loads do not flash. */
  (function () {
    function mark(img) { img.classList.add('is-loaded'); }
    /* Flag what is already decoded BEFORE the gate goes on. The class hides
       every unloaded [data-rd-fade] image, and this runs after first paint --
       so anything still in flight would be yanked back to opacity:0 having
       already painted. Marking first closes that window. */
    var fading = document.querySelectorAll('img[data-rd-fade]');
    fading.forEach(function (img) { if (img.complete && img.naturalWidth) mark(img); });
    document.documentElement.classList.add('rd-fade-ready');
    function watch(img) {
      if (img.complete && img.naturalWidth) mark(img);
      else {
        img.addEventListener('load', function () { mark(img); }, { once: true });
        /* A broken image must not stay invisible. */
        img.addEventListener('error', function () { mark(img); }, { once: true });
      }
    }
    fading.forEach(watch);
    /* Images inserted after load (the recently viewed strip's cards) would be
       held at opacity 0 by the gate above with nothing to release them; their
       inserter hands them over here. */
    window.rdFadeIn = function (scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('img[data-rd-fade]:not(.is-loaded)'), watch);
    };
  })();

  /* The sticky offset used to be measured here and written to --rd-trust-h.
     That was the cause of the header jumping when the page was reloaded at a
     scrolled position: the offset started at the CSS fallback and changed the
     moment this ran, after first paint. --rd-trust-h is now declared in CSS and
     the trust bar's height is set FROM it, so the two cannot disagree and the
     header is pinned correctly on the very first frame. No JS involved. */

  /* -------------------------------------------------- header nav (desktop) */
  /* Hover opens on pointer devices; click and keyboard work everywhere, so it
     is usable on touch and by keyboard without a separate code path. */
  (function () {
    var items = document.querySelectorAll('.rd-nav__item--has-menu');
    if (!items.length) return;
    var hoverable = window.matchMedia('(hover: hover)').matches;

    function closeAll(except) {
      items.forEach(function (li) {
        if (li === except) return;
        setOpen(li, false);          /* via setOpen so these fade out too */
      });
    }

    /* CLOSING IS ANIMATED TOO.

       Opening played rdFadeUp and closing just dropped display:none, so the
       panel appeared gently and vanished on a frame. Mirrors the drawer's
       is-opening/is-closing pattern: the class stays on until the fade-out
       ends, then is-open comes off. Guarded on e.target because animationend
       bubbles — the panel is full of animated children, and the first one to
       finish would otherwise close the menu. */
    var EXIT_MS = 160;

    function setOpen(li, open) {
      var a = li.querySelector('.rd-nav__link');
      if (a) a.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (open) {
        if (li.__closeFn) {
          li.removeEventListener('animationend', li.__closeFn);
          li.__closeFn = null;
        }
        li.classList.remove('is-closing');
        li.classList.add('is-open');
        return;
      }
      if (!li.classList.contains('is-open') || li.classList.contains('is-closing')) return;

      var panel = li.querySelector('.rd-mega, .rd-drop');
      if (!panel || !window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
        li.classList.remove('is-open', 'is-closing');
        return;
      }
      li.classList.add('is-closing');
      var done = false;
      var fn = function (e) {
        if (e && e.target !== panel) return;      /* animationend bubbles */
        if (done) return;
        done = true;
        li.removeEventListener('animationend', fn);
        li.__closeFn = null;
        li.classList.remove('is-open', 'is-closing');
      };
      li.__closeFn = fn;
      li.addEventListener('animationend', fn);
      setTimeout(fn, EXIT_MS + 60);               /* if the animation never runs */
    }

    /* Short close delay. The nav item now spans the full bar height so there is
       no dead gap to the panel, but a grace period still saves a menu from
       closing on a fast diagonal cut across a neighbouring item. */
    var closeTimer = null;
    function cancelClose() { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } }

    items.forEach(function (li) {
      var link = li.querySelector('.rd-nav__link');

      if (hoverable) {
        li.addEventListener('mouseenter', function () { cancelClose(); closeAll(li); setOpen(li, true); });
        li.addEventListener('mouseleave', function () {
          cancelClose();
          closeTimer = setTimeout(function () { setOpen(li, false); }, 140);
        });
      }

      /* First tap opens rather than navigating; second tap follows the link. */
      if (link) {
        link.addEventListener('click', function (e) {
          if (hoverable) return;
          if (!li.classList.contains('is-open')) {
            e.preventDefault();
            closeAll(li);
            setOpen(li, true);
          }
        });
      }

      li.addEventListener('focusin', function () { closeAll(li); setOpen(li, true); });
      li.addEventListener('focusout', function (e) {
        if (!li.contains(e.relatedTarget)) setOpen(li, false);
      });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.rd-nav__item--has-menu')) closeAll(null);
    });
  })();

  /* ----------------------------------------------------------- search box */
  (function () {
    var wrap = document.querySelector('[data-rd-search]');
    if (!wrap) return;
    var btn = wrap.querySelector('[data-rd-search-toggle]');
    var input = wrap.querySelector('[data-rd-search-input]');
    var cluster = document.querySelector('[data-rd-cluster]');

    var bar = wrap.closest('.rd-header__bar');

    /* ---- nav items the open field would sit on top of -------------------
       Between 1100px and roughly 1400px the field expands into space the nav
       is still using. .rd-nav is flex:1 min-width:0 so its BOX shrinks, but
       .rd-nav__list does not reflow — the links keep their positions and
       simply overflow. And because .rd-nav__item is position:relative while
       .rd-search is static, the nav paints ABOVE the field, so the overflowing
       link reads straight through the open search rather than being covered.
       At 1150px that is the whole of "Formula Quiz" sitting on the field.

       Fading only the links actually reached keeps the rest of the nav, which
       is why this is not just hiding .rd-nav wholesale. They keep their place
       in the row rather than being pulled out of flow: removing them would
       reflow the survivors and shuffle the bar sideways at the exact moment
       the field is animating across it.

       Not solved with overflow:hidden on .rd-nav — the mega panels are
       position:absolute children and would be clipped to the bar. */
    var nav = document.querySelector('.rd-nav');
    var actions = document.querySelector('.rd-header__actions');
    var navItems = nav ? [].slice.call(nav.querySelectorAll('.rd-nav__item')) : [];
    var openLeft = null, measuredAt = -1;

    /* Under 1100px the nav is display:none and the field goes absolute across
       the whole bar. Nothing to fade there, and — more to the point — a
       threshold measured in that layout is meaningless in the desktop one. */
    function navIsLaidOut() {
      return !!(nav && nav.offsetParent && nav.getBoundingClientRect().width);
    }

    /* Keyed on the viewport width rather than merely cached. Invalidating on
       the resize event alone was not enough: a threshold measured in the
       burger layout survived into the desktop one and hid six of seven links,
       because down there the open field starts at the gutter. */
    function primeOpenLeft() {
      if (openLeft !== null && measuredAt === window.innerWidth) return openLeft;
      openLeft = measureOpenLeft();
      measuredAt = window.innerWidth;
      return openLeft;
    }

    /* Where the actions cluster STARTS once the field has finished opening.
       Measured rather than derived: the open width is 324px or 240px by
       breakpoint and the cluster's collapse plays into it too. Read with
       transitions suppressed and undone in the same frame, so nothing paints
       and the real animation is never interrupted. */
    function measureOpenLeft() {
      if (!actions || !navItems.length) return null;
      if (wrap.classList.contains('is-open')) return actions.getBoundingClientRect().left;
      var freeze = document.createElement('style');
      freeze.textContent = '.rd-header__bar, .rd-header__bar * { transition: none !important; }';
      document.head.appendChild(freeze);
      wrap.classList.add('is-open');
      if (cluster) cluster.classList.add('is-collapsed');
      var left = actions.getBoundingClientRect().left;
      wrap.classList.remove('is-open');
      if (cluster) cluster.classList.remove('is-collapsed');
      actions.getBoundingClientRect();   /* flush before transitions return */
      freeze.remove();
      return left;
    }

    function applyNavFade(open) {
      if (!navItems.length) return;
      if (!open || !navIsLaidOut()) {
        navItems.forEach(function (i) { i.classList.remove('is-search-hidden'); });
        return;
      }
      var left = primeOpenLeft();
      if (left === null) return;
      /* A hair of clearance so a surviving link cannot end flush against the
         field, but deliberately NOT the bar's full 28px gap: at 1150px that
         would also take "Blog", which ends 16px clear of the field and never
         actually collides. The brief was the links it overlaps, not the links
         near it. */
      var limit = left - 8;
      navItems.forEach(function (i) {
        var r = i.getBoundingClientRect();
        /* display:none under 1100px gives an all-zero rect, which fails this
           test on its own — no special case needed for the burger layout. */
        i.classList.toggle('is-search-hidden', r.width > 0 && r.right > limit);
      });
    }

    function setOpen(open) {
      /* Take the measurement BEFORE is-open goes on. Once it is on, the probe
         takes its "already open, just read it" path and reads the field one
         frame into a 300ms width transition — i.e. still the closed geometry.
         That silently produced a threshold ~90px too far right. */
      if (open && navIsLaidOut()) primeOpenLeft();
      wrap.classList.toggle('is-open', open);
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (cluster) cluster.classList.toggle('is-collapsed', open);
      /* Drives the logo fade and the ordered collapse — see redesign.css. */
      if (bar) bar.classList.toggle('is-searching', open);
      applyNavFade(open);
      if (open && input) input.focus();
    }

    /* The breakpoint changes both the open width and which links fit, so the
       cached measurement cannot survive a resize. */
    window.addEventListener('resize', function () {
      /* primeOpenLeft re-measures on its own when the width has changed, so
         this only has to re-apply for a field that is already open. */
      if (wrap.classList.contains('is-open')) applyNavFade(true);
    });

    if (btn) {
      btn.addEventListener('click', function () {
        /* With text entered, the button submits instead of collapsing. */
        if (wrap.classList.contains('is-open') && input && input.value.trim()) {
          wrap.querySelector('form').submit();
          return;
        }
        setOpen(!wrap.classList.contains('is-open'));
      });
    }
    if (input) {
      input.addEventListener('blur', function () {
        if (!input.value.trim()) setOpen(false);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && wrap.classList.contains('is-open')) setOpen(false);
    });
  })();

  /* ------------------------------------------------------- overlay exits ----
   animationend and transitionend BOTH BUBBLE. Every overlay here waited for
   one with { once: true } and no target check, so the first animation or
   transition to finish anywhere inside the panel — a facet option's colour
   change, any child at all — consumed the listener and hid the overlay while
   the scrim was still half-opaque. That is the abrupt cut: the fade never got
   to finish, it was interrupted.

   rdExit waits for the elements it is given, ignores anything that merely
   bubbled through them, and calls back once when the LAST of them is done.
   The timeout is the floor for reduced motion and background tabs, where the
   events may never arrive at all. */
function rdExit(els, ms, done) {
  var fired = false;
  function finish() {
    if (fired) return;
    fired = true;
    els.forEach(function (x) {
      if (!x.el) return;
      x.el.removeEventListener('animationend', x.fn);
      x.el.removeEventListener('transitionend', x.fn);
    });
    done();
  }
  var left = 0;
  els.forEach(function (x) {
    if (!x.el) return;
    left++;
    x.fn = function (e) {
      /* Only this element's own event — not a descendant's. */
      if (e.target !== x.el) return;
      x.el.removeEventListener('animationend', x.fn);
      x.el.removeEventListener('transitionend', x.fn);
      if (--left <= 0) finish();
    };
    x.el.addEventListener('animationend', x.fn);
    x.el.addEventListener('transitionend', x.fn);
  });
  if (!left) { finish(); return; }
  setTimeout(finish, ms);
}

  /* ---------------------------------------------------------- nav drawer */
  (function () {
    var drawer = document.querySelector('[data-rd-drawer]');
    if (!drawer) return;
    var burger = document.querySelector('[data-rd-drawer-open]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      /* Reopened mid-close: drop the closing state so it does not finish and
         hide the drawer we have just reopened. */
      drawer.classList.remove('is-closing');
      drawer.hidden = false;
      drawer.classList.add('is-opening');
      document.body.classList.add('rd-drawer-open');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      var c = drawer.querySelector('.rd-drawer__close');
      if (c) c.focus();
    }

    /* [hidden] has to wait for the animation. Setting it straight away removes
       the element in the same frame, so the close was never seen — same fix the
       cart drawer already carries. The timeout is the fallback for reduced
       motion and background tabs, where animationend may never fire. */
    function close() {
      if (drawer.hidden || drawer.classList.contains('is-closing')) return;
      drawer.classList.remove('is-opening');
      drawer.classList.add('is-closing');
      if (burger) burger.setAttribute('aria-expanded', 'false');

      var done = false;
      function finish() {
        if (done) return;
        done = true;
        drawer.classList.remove('is-closing');
        /* The scroll lock comes off with the drawer, not ahead of it. Released
           at the top of close() it returned the scrollbar and reflowed the page
           while the panel was still sliding out — a visible nudge under a
           moving overlay. The cart and the popup already release it here. */
        document.body.classList.remove('rd-drawer-open');
        /* Reopened while closing — leave it alone. */
        if (!drawer.classList.contains('is-opening')) drawer.hidden = true;
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      rdExit([
        { el: drawer.querySelector('.rd-drawer__panel') },
        { el: drawer.querySelector('.rd-drawer__scrim') }
      ], 420, finish);
    }

    if (burger) burger.addEventListener('click', open);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-rd-drawer-close]')) close();
    });

    /* Disclosure submenus inside the drawer, animated. Height has to be pinned
       to a pixel value for the duration — you cannot transition to or from auto —
       and is cleared afterwards so nested submenus opening inside can still grow
       the parent. */
    var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

    function slide(panel, open) {
      if (REDUCED_MOTION.matches) { panel.hidden = !open; return; }
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        panel.style.height = '';
        panel.style.opacity = '';
        if (!open) panel.hidden = true;
      }
      if (open) {
        panel.hidden = false;
        var target = panel.scrollHeight;
        panel.style.height = '0px';
        panel.style.opacity = '0';
        void panel.offsetHeight;
        panel.style.height = target + 'px';
        panel.style.opacity = '1';
      } else {
        panel.style.height = panel.scrollHeight + 'px';
        void panel.offsetHeight;
        panel.style.height = '0px';
        panel.style.opacity = '0';
      }
      panel.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 400);
    }

    drawer.addEventListener('click', function (e) {
      var t = e.target.closest('.rd-drawer__toggle');
      if (!t) return;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (!panel) return;
      var open_ = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', open_ ? 'false' : 'true');
      slide(panel, !open_);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
      if (e.key === 'Tab' && !drawer.hidden) {
        var f = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
        var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
        if (!vis.length) return;
        var first = vis[0], last = vis[vis.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    /* Leaving mobile width with the drawer open would strand it off-canvas. */
    window.matchMedia('(min-width: 1101px)').addEventListener('change', function (ev) {
      if (ev.matches && !drawer.hidden) close();
    });
  })();

  /* ------------------------------------------------------- lost-add guard
     A THIRD-PARTY WRITE CAN WIPE AN ADD. The Analyzely app embed writes to the
     cart through the Storefront API (cartMetafieldsSet) when a page finishes
     loading and again after the first cart change. When that lands on top of a
     /cart/add.js, Shopify can keep the cart WITHOUT the new line although the
     add answered 200 and its section render showed it — 3 of 6 fresh runs on
     the live cart page lost a unit (18 Sep 2026). Every add in this theme
     hands its response here.

     watch(response, readd, opts): once things have settled, read the cart
     back; any added line that is missing or short on TWO reads (`gap` apart)
     is added again with its own selling plan and properties. readd(items) is
     the surface's own add, so the repair re-renders it; without one the guard
     posts itself. At most two repair rounds. If one of our own cart writes
     happens in between (the epoch, counted off window.fetch) the shopper has
     moved on, and their cart stands. */
  window.rdCartGuard = (function () {
    var base = window.fetch && window.fetch.bind(window);
    if (!base || !window.Promise) return { watch: function () { return Promise.resolve(false); } };

    var epoch = 0;
    var MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method === 'POST' && MUTATION.test(url)) epoch++;
      return base.apply(null, arguments);
    };

    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
    function read() {
      return base('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });
    }
    /* /cart/add.js answers with the line (one item) or { items: [...] }; each
       line's quantity is the line's TOTAL after the add, so "short" also
       catches an increment that was reverted, not only a vanished line. */
    function wanted(data) {
      var list = data ? (data.items || (data.key ? [data] : [])) : [];
      return list.filter(function (l) { return l && l.key; }).map(function (l) {
        var plan = l.selling_plan_allocation && l.selling_plan_allocation.selling_plan;
        return { key: l.key, id: l.variant_id || l.id, qty: l.quantity, plan: plan ? plan.id : null, props: l.properties };
      });
    }
    function shortfall(cart, want) {
      var have = {};
      (cart.items || []).forEach(function (i) { have[i.key] = (have[i.key] || 0) + i.quantity; });
      return want.filter(function (w) { return (have[w.key] || 0) < w.qty; }).map(function (w) {
        var item = { id: w.id, quantity: w.qty - (have[w.key] || 0) };
        if (w.plan) item.selling_plan = w.plan;
        if (w.props && Object.keys(w.props).length) item.properties = w.props;
        return item;
      });
    }
    function post(items) {
      return base('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.ok ? r.json() : null; });
    }
    function watch(data, readd, opts) {
      opts = opts || {};
      var want = wanted(data);
      if (!want.length) return Promise.resolve(false);
      var mine = epoch;
      var round = opts.round || 0;
      var first = opts.delay == null ? 900 : opts.delay;
      var gap = opts.gap == null ? 600 : opts.gap;
      return wait(first).then(read).then(function (cart) {
        if (epoch !== mine || !shortfall(cart, want).length) return false;
        return wait(gap).then(read).then(function (again) {
          var items = shortfall(again, want);
          if (epoch !== mine || !items.length || round >= 2) return false;
          return Promise.resolve(readd ? readd(items) : post(items)).then(function (res) {
            return watch(res, readd, { delay: first, gap: gap, round: round + 1 });
          }).then(function () { return true; });
        });
      }).catch(function () { return false; });
    }
    return { watch: watch };
  })();

  /* ---------------------------------------------------------- cart drawer */
  /* The upsell inside the drawer is NOT handled here — product-top-upsell.liquid
     binds its own delegated, window-guarded handler. Touching it would put a
     revenue path back under test for no benefit. */
  (function () {
    var cart = document.querySelector('[data-rd-cart]');
    /* NO DRAWER ON THIS PAGE is not a reason to bail. The cart page suppresses
       the drawer but retargets this very engine (window.rdCart.retarget), and
       an early return here left window.rdCart undefined — which is why the cart
       page silently fell back to a cruder, unanimated update path.

       A detached stand-in keeps every drawer-only listener bound to something
       harmless, and open() no-ops without a real drawer. */
    var hasDrawer = !!cart;
    if (!cart) cart = document.createElement('div');
    var lastFocus = null;

    function open() {
      if (!hasDrawer) return;
      lastFocus = document.activeElement;
      cart.hidden = false;
      document.body.classList.add('rd-cart-open');
      /* is-opening drives the slide-in. It has to come off once played,
         otherwise refresh() re-rendering the panel would replay it and look like
         the drawer closed and reopened. */
      cart.classList.add('is-opening');
      var panel = cart.querySelector('.rd-cart__panel');
      var clear = function () { cart.classList.remove('is-opening'); };
      if (panel) panel.addEventListener('animationend', clear, { once: true });
      setTimeout(clear, 400);
      var c = cart.querySelector('.rd-cart__close');
      if (c) c.focus();
    }

    /* Animate out before hiding: [hidden] alone removes the panel instantly, so
       the closing class runs the animation and animationend does the hide. The
       timeout is a fallback for reduced-motion and background tabs. */
    function close() {
      if (cart.hidden || cart.classList.contains('is-closing')) return;
      cart.classList.add('is-closing');
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        cart.classList.remove('is-closing');
        cart.hidden = true;
        document.body.classList.remove('rd-cart-open');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      rdExit([
        { el: cart.querySelector('.rd-cart__panel') },
        { el: cart.querySelector('.rd-cart__scrim') }
      ], 420, finish);
    }

    /* The pill is a real /cart link; intercept only when we can do better. */
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-rd-cart-open]');
      if (t) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-rd-cart-close]') && cart.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !cart.hidden) close();
      if (e.key === 'Tab' && !cart.hidden) {
        var f = cart.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
        var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
        if (!vis.length) return;
        var first = vis[0], last = vis[vis.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    /* Must match Liquid's `| money | remove: '.00'` exactly, including the
       thousands separator — without grouping the tween turned a server-rendered
       "$1,039.59" into "$1050.59" mid-animation. Thin wrappers over rdMoney
       (top of this file), which reads the session's real shape off the
       layout's sample, so that now holds in any currency, not only dollars.
       withCode is D3's currency code on a total ("$45.99 CAD"); callers pass
       what the server printed rather than deciding (see tweenMoney). */
    function money(cents, withCode) {
      return rdMoney.format(cents, { trailingZeros: false, withCode: withCode });
    }

    /* Same shape snippets/redesign-money.liquid emits, so the figure does not
       reflow when the tween takes over from the server-rendered markup. */
    function moneyHTML(cents, withCode) {
      return rdMoney.formatHTML(cents, { withCode: withCode });
    }

    /* ---- money tweening -------------------------------------------------
       Prices count from the old figure to the new one instead of snapping.
       Cheap: parse both ends to cents and interpolate on rAF with an
       ease-out, reusing the same money() formatter so the currency string
       never diverges. Skipped entirely under reduced-motion. */
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* The inverse, through the same detected separators. The old /[^0-9.]/
       read made 3,499 euros of "€34,99" and 1.04 of "€1.039,59". */
    function readCents(el) {
      if (!el) return null;
      return rdMoney.parse(el.textContent);
    }

    /* Never writes the OLD value synchronously. An earlier version did, then
       relied on rAF to advance it — but rAF is paused in a backgrounded tab, so
       the total could be left showing a stale figure indefinitely. Now the
       server-rendered value stays put until the first frame actually runs, and
       the last frame always writes the exact target. */
    function tweenMoney(el, from, to) {
      /* Remember the destination. snapshotMoney() runs immediately after an
         optimistic write, but tweenMoney deliberately does not paint the first
         frame synchronously — so the DOM still reads the OLD figure and the
         snapshot captured it. animateMoneyFrom() then counted from old to new a
         SECOND time after the section swap, which is the double animation. */
      if (el) el.__rdTo = to;
      if (!el || from === null || to === null || from === to || REDUCED.matches) return;
      if (document.hidden) return;
      var t0 = null, ms = 420;
      /* Keep the shape the server gave this figure: a total outside the store
         currency carries its code (D3), a line price does not. Read once,
         from the figure as it stands before the first frame. */
      var code = rdMoney.hasCode(el.textContent);
      function step(now) {
        if (t0 === null) t0 = now;
        var p = Math.min(1, (now - t0) / ms);
        if (p < 1) {
          var e = 1 - Math.pow(1 - p, 3);
          el.innerHTML = moneyHTML(Math.round(from + (to - from) * e), code);
          requestAnimationFrame(step);
        } else {
          el.innerHTML = moneyHTML(to, code);
        }
      }
      requestAnimationFrame(step);
    }

    /* ---- the surface this engine drives ---------------------------------
       Everything below was written for the drawer and is the tuned version:
       an optimistic tween on click, a count-up reconcile against the server,
       new rows easing in, removals collapsing, the upsell revealing. The cart
       PAGE runs this same code rather than a second implementation — it points
       these at its own root and hooks via window.rdCart.retarget(). */
    var ROOT = cart;
    var SEL = {
      line: '[data-rd-key]',
      linePrice: '[data-rd-line-price], .rd-cart__line-price',
      total: '[data-rd-cart-total]',
      qtyVal: '[data-rd-qty-val]',
      upsellBlock: '[data-rd-upsell-block]',
      /* Other money figures on the surface that should count up to their new
         value after a re-render — the cart page's subtotal and savings. They
         cannot be predicted optimistically (savings depends on compare-at
         prices, which the line does not carry), but they can be reconciled the
         same way the total is: remember what they read, then tween to whatever
         the server rendered. The drawer names none. */
      extras: []
    };

    /* Snapshot every money figure, keyed so rows can be matched back up after
       the DOM is replaced. */
    /* Where a figure is HEADING, falling back to what it currently reads. */
    function targetCents(el) {
      if (!el) return null;
      return (el.__rdTo != null) ? el.__rdTo : readCents(el);
    }

    function snapshotMoney() {
      var snap = { total: targetCents(ROOT.querySelector(SEL.total)), lines: {}, keys: {}, extras: {} };
      (SEL.extras || []).forEach(function (sel) {
        snap.extras[sel] = targetCents(ROOT.querySelector(sel));
      });
      ROOT.querySelectorAll(SEL.line).forEach(function (line) {
        var key = line.getAttribute('data-rd-key');
        snap.keys[key] = true;
        var price = line.querySelector(SEL.linePrice);
        if (price) snap.lines[key] = targetCents(price);
      });
      return snap;
    }

    /* Any line key present after a refresh but not before is newly added — ease
       it in rather than letting it pop. */
    function markNewLines(snap) {
      ROOT.querySelectorAll(SEL.line).forEach(function (line) {
        if (snap.keys[line.getAttribute('data-rd-key')]) return;
        line.classList.remove('is-entering');
        void line.offsetWidth;
        line.classList.add('is-entering');
      });
    }

    /* Collapse a row's height away before the request goes out, so removal reads
       as the item leaving rather than the list snapping shut. Height has to be
       pinned to its measured px first — you cannot transition from auto. */
    function collapseLine(line) {
      return new Promise(function (resolve) {
        if (REDUCED.matches) return resolve();
        line.style.height = line.offsetHeight + 'px';
        void line.offsetHeight;
        line.classList.add('is-removing');
        line.style.height = '0px';
        var done = false;
        function fin() { if (done) return; done = true; resolve(); }
        line.addEventListener('transitionend', fin, { once: true });
        setTimeout(fin, 400);
      });
    }

    function animateMoneyFrom(snap) {
      var totalEl = ROOT.querySelector(SEL.total);
      tweenMoney(totalEl, snap.total, readCents(totalEl));
      (SEL.extras || []).forEach(function (sel) {
        var el = ROOT.querySelector(sel);
        if (el && snap.extras) tweenMoney(el, snap.extras[sel], readCents(el));
      });
      ROOT.querySelectorAll(SEL.line).forEach(function (line) {
        var key = line.getAttribute('data-rd-key');
        if (!(key in snap.lines)) return;   /* newly added row — nothing to count from */
        var price = line.querySelector(SEL.linePrice);
        tweenMoney(price, snap.lines[key], readCents(price));
      });
    }

    /* Re-render the drawer from the server via the Section Rendering API, so
       line rows, totals, the upsell's visibility and the free-shipping bar all
       come back consistent without a page load. Falls back to a reload if the
       API is unavailable or the shape is unexpected — never leaves the cart
       showing stale numbers. */
    /* Swap in freshly rendered drawer markup. Split out from refresh() so the
       same code path can consume HTML that came back on the cart mutation itself
       (see SECTIONS below) instead of costing a second round trip. */
    function applySection(html, snap, cart_) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-rd-cart]');
      if (!fresh) throw new Error('drawer missing from section');

      var wasOpen = !cart.hidden;
      /* Captured BEFORE the swap: the re-rendered fill is a brand-new node with
         no width to ease from, so the bar would jump. See prime() below. */
      var barWidths = window.olsFreeShipping && window.olsFreeShipping.widths();
      cart.innerHTML = fresh.innerHTML;
      cart.hidden = !wasOpen;
      animateMoneyFrom(snap);
      markNewLines(snap);

      var freshCount = doc.querySelector('[data-rd-cart-count]');
      if (freshCount) {
        document.querySelectorAll('[data-rd-cart-count]').forEach(function (el) {
          el.textContent = freshCount.textContent;
          el.classList.toggle('is-empty', freshCount.textContent.trim() === '0');
        });
      }

      /* free-shipping.liquid listens for these; its inline script is not
         re-executed by innerHTML, but its handler is still bound from the
         original page load and re-queries the DOM each time.

         When the mutation handed back a whole cart — /cart/change.js does,
         /cart/add.js hands back the added line instead — paint the bar from it
         directly. The bar otherwise refetches /cart.js to learn what we already
         know, which leaves a frame showing the pre-update side of the
         threshold. The threshold rules stay in free-shipping.liquid. */
      if (window.olsFreeShipping) {
        window.olsFreeShipping.prime(barWidths);
        if (cart_ && cart_.items) window.olsFreeShipping.paintFromCart(cart_);
      }

      ['cart:updated', 'cart:refresh'].forEach(function (evt) {
        document.dispatchEvent(new CustomEvent(evt));
      });

      /* The rows are new, so the note has to be put back on if it is still
         within its few seconds, and a line that came back over one capped. */
      paintStarterNote();
      capStarters();
    }

    /* SECTIONS: the Cart AJAX API renders sections in the SAME response as the
       mutation when asked, so add/change need one request rather than two
       sequential ones. That second round trip was most of the perceived lag. */
    var SECTION_ID = 'redesign-header';

    function sectionFromCartResponse(data) {
      return data && data.sections && data.sections[SECTION_ID];
    }

    /* Fallback only — used when a mutation response carries no sections. */
    function refresh(snap) {
      snap = snap || snapshotMoney();
      var url = '/?sections=' + SECTION_ID + '&_=' + Date.now();
      return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) {
          if (!r.ok) throw new Error('sections ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var html = data[SECTION_ID];
          if (!html) throw new Error('section missing from payload');
          applySection(html, snap);
        })
        .catch(function (err) {
          console.error('Cart refresh failed, reloading:', err);
          window.location.reload();
        });
    }

    /* Recompute a line and the total locally so the figures move the instant the
       button is pressed. The unit price comes from data-rd-unit (item.final_price)
       rather than dividing the line total, so there is no rounding drift. The
       server response still reconciles afterwards — this is presentation only. */
    /* `silent` writes the same figures without counting up to them. It is for
       RESTORING a value the customer has already watched arrive — after a
       section swap resets the DOM to the server's older number — where a second
       count-up is the bug, not the feature. */
    function applyOptimistic(line, newQty, silent) {
      var unit = parseInt(line.getAttribute('data-rd-unit'), 10);
      var qtyEl = line.querySelector(SEL.qtyVal);
      if (isNaN(unit) || !qtyEl) return false;
      var oldQty = parseInt(qtyEl.textContent.trim(), 10);
      if (isNaN(oldQty)) return false;

      qtyEl.textContent = newQty;

      function put(el, from, to) {
        if (!el) return;
        if (silent) { el.__rdTo = to; el.innerHTML = moneyHTML(to, rdMoney.hasCode(el.textContent)); }
        else tweenMoney(el, from, to);
      }

      var priceEl = line.querySelector(SEL.linePrice);
      put(priceEl, readCents(priceEl), unit * newQty);

      /* Base the new total on where the total is HEADING, not on what it reads
         right now. A second click while the first tween is still running used to
         read a half-counted figure — the customer clicks + twice quickly and the
         second step is computed from, say, T+0.6U instead of T+U, so the target
         lands short. The server then corrects it, and that correction is a
         second visible count-up of a step already shown. Animate FROM what is
         painted (so it stays smooth) TO the figure derived from the target. */
      var totalEl = ROOT.querySelector(SEL.total);
      var aim = targetCents(totalEl);
      if (aim !== null) {
        put(totalEl, readCents(totalEl), aim + unit * (newQty - oldQty));
      }

      document.querySelectorAll('[data-rd-cart-count]').forEach(function (el) {
        var n = parseInt(el.textContent.trim(), 10);
        if (!isNaN(n)) {
          var next = n + (newQty - oldQty);
          el.textContent = next;
          el.classList.toggle('is-empty', next === 0);
        }
      });
      return true;
    }

    /* Upsell add, without the page reload product-top-upsell.liquid would do.
       This listener is on the drawer, so it runs BEFORE that snippet's
       document-level delegated handler; stopPropagation keeps the reload from
       ever firing. The snippet's own markup and its visibility logic are
       untouched — only the navigation is overridden. */
    cart.addEventListener('click', function (e) {
      var opt = e.target.closest('.subscription-option');
      if (!opt || !cart.contains(opt)) return;
      e.preventDefault();
      e.stopPropagation();

      var id = opt.getAttribute('data-product-id');
      if (!id || opt.classList.contains('is-busy')) return;
      opt.classList.add('is-busy');

      var block = opt.closest('[data-rd-upsell-block]');
      if (block) block.classList.add('is-hidden');

      var payload = { id: id, quantity: 1 };
      var sellingId = opt.getAttribute('data-selling-id');
      if (sellingId) payload.selling_plan = sellingId;

      var snap = snapshotMoney();
      payload.sections = SECTION_ID;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) throw new Error('cart/add.js ' + r.status);
        return r.json();
      }).then(function (data) {
        var html = sectionFromCartResponse(data);
        if (html) applySection(html, snap, data);
        window.rdCartGuard.watch(data, readdLines);
        if (!html) return refresh(snap);
      }).catch(function (err) {
        console.error('Upsell add failed:', err);
        opt.classList.remove('is-busy');
        if (block) block.classList.remove('is-hidden');
      });
    }, true);

    /* NEXT-STAGE OFFER. The cart page has its own handler for these buttons
       in redesign-cart.js, bound to the page's section root; this one is bound
       to the drawer, so neither ever sees the other's clicks. Same shape as
       there: one add at a time, queued so an add fired during a guard repair
       waits for it instead of racing it, and the section swap that follows
       re-decides the offer (adding Stage 2 makes it offer Stage 3).

       The button is a real /cart/add link underneath, so this only has to
       undo its own busy state on failure — the link still works with no JS. */
    var nsQueue = Promise.resolve();

    cart.addEventListener('click', function (e) {
      var add = e.target.closest('[data-rd-ns-add]');
      if (!add || !cart.contains(add)) return;
      e.preventDefault();
      if (add.classList.contains('is-busy')) return;

      var id = parseInt(add.getAttribute('data-rd-ns-add'), 10);
      if (!id) return;
      add.classList.add('is-busy');
      add.setAttribute('aria-disabled', 'true');

      nsQueue = nsQueue.then(function () {
        return addAndRender({ id: id, quantity: 1 }).then(function (data) {
          window.rdCartGuard.watch(data, readdLines);
        }).catch(function (err) {
          console.error('Next-stage add failed:', err);
          add.classList.remove('is-busy');
          add.removeAttribute('aria-disabled');
        });
      });
    });

    /* WHAT IS IN FLIGHT, KEYED BY LINE — not by a class on the row.
       applySection() replaces every row on every response, so a class was only
       ever as durable as the next re-render (see the guard below). Keys are
       held here, outside the DOM, and released when the request settles.

       cartSeq/cartApplied drop a response that is older than one already
       applied: two removals in flight can come back out of order, and the
       older payload still lists the line the newer one removed. */
    var busyLines = Object.create(null);
    /* HOW A BURST IS RECONCILED. Each response is applied as it arrives, so a
       single change still repaints immediately — but concurrent changes cannot
       be ordered from here. Shopify processes them in ITS arrival order, which
       is not the order they were sent, so the last response to come back is
       not necessarily the newest state: three removals fired together came
       back with one of them describing a cart that still held a line every
       other request had already removed, and the drawer kept that row while
       the cart itself was empty.

       Sequencing the requests does not fix it, because the sequence is of
       sends, not of server writes. So: when the LAST request of a burst
       settles, and only when there was more than one in flight, the drawer is
       re-rendered once from the cart as it actually is. One extra round trip
       per burst, none at all for the ordinary single change. */
    var cartPending = 0, cartBurst = false;

    /* Quantity and remove are real /cart/change links. Intercept them, do it
       over AJAX, and re-render from the response. */
    cart.addEventListener('click', function (e) {
      var link = e.target.closest('[data-rd-qty-step], [data-rd-remove]');
      if (!link) return;
      var line = link.closest('[data-rd-line]');
      if (!line) return;

      e.preventDefault();
      /* The line item key, which /cart/change.js also accepts. Unlike the
         index it survives other lines being removed, so a click during another
         line's collapse can no longer address the wrong row. The index stays
         as the fallback for a line rendered without a key. */
      var key = line.getAttribute('data-rd-key');
      var lineNo = parseInt(line.getAttribute('data-rd-line'), 10);
      var token = key || ('line:' + lineNo);

      /* A second click while this line's change is in flight is what produced
         Shopify's error page: the request asks it to remove a line it has
         already removed, that answers 404, and the catch used to navigate to
         the link's own href — /cart/change?id=…&quantity=0 for a line that no
         longer exists, which is an error page by construction.

         THE GUARD USED TO BE `line.classList.contains('is-busy')` (10 Sep
         2026, Sam: removing several items quickly landed on that page). Every
         response re-renders the whole drawer, so the row carrying the class
         was replaced within a few hundred milliseconds and the next click
         found a fresh, un-busy row for a removal that was still in flight.
         Guarding on the key survives any number of re-renders.

         preventDefault runs FIRST and then this bails — returning earlier
         would let the stale href navigate, which is the same error page. */
      if (busyLines[token]) return;
      busyLines[token] = true;

      var qty;
      if (link.hasAttribute('data-rd-remove')) {
        qty = 0;
      } else {
        var cur = parseInt(line.querySelector(SEL.qtyVal).textContent.trim(), 10) || 1;
        qty = cur + parseInt(link.getAttribute('data-rd-qty-step'), 10);
      }
      if (qty < 0) qty = 0;

      /* Instant feedback: recompute the line and total locally before the network
         is touched. A quantity step is just unit x qty, so making the customer
         wait two round trips to see it was pure latency. Skipped for removals,
         which collapse the row instead. */
      if (qty > 0) applyOptimistic(line, qty);
      /* Snapshot AFTER the optimistic write, so the server render reconciles
         against what the customer is already looking at and does not replay the
         count-up a second time. */
      var snap = snapshotMoney();

      line.classList.add('is-busy');

      /* Removals collapse first; quantity steps stay immediate. */
      var ready = (qty === 0) ? collapseLine(line) : Promise.resolve();

      /* Reveal the offer straight away when its own row is removed, instead of
         waiting on the Section Rendering round trip — that delay is what made it
         appear a beat late. The refresh still confirms the state afterwards. */
      if (qty === 0 && line.classList.contains('rd-cart__line--upsell')) {
        var block = cart.querySelector('[data-rd-upsell-block]');
        if (block && block.classList.contains('is-hidden')) {
          block.classList.remove('is-hidden');
          void block.offsetWidth;
          block.classList.add('is-revealing');
        }
      }

      cartPending++;
      if (cartPending > 1) cartBurst = true;

      ready.then(function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(key
          ? { id: key, quantity: qty, sections: SECTION_ID }
          : { line: lineNo, quantity: qty, sections: SECTION_ID })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart/change.js ' + r.status);
        return r.json();
      }).then(function (data) {
        /* The re-render is what keeps line numbering, the upsell's visibility
           and the shipping bar correct after a removal — and it reconciles the
           optimistic figures against the server's authoritative ones. */
        var html = sectionFromCartResponse(data);
        if (html) applySection(html, snap, data);
        else return refresh(snap);
      });
      }).catch(function (err) {
        /* NEVER THE STALE href. It used to navigate to link.href on any
           failure, and the commonest failure here is Shopify answering 404 for
           a line that is already gone — so the fallback loaded the one URL
           guaranteed to render an error page, for a cart that was in fact
           correct.

           refresh() re-renders the drawer from the cart as it actually is, and
           reloads the page itself if even that fails. Either way the customer
           ends up looking at their real cart rather than at Shopify's
           "Cart Error". */
        console.error('Cart update failed, re-rendering from the server:', err);
        return refresh();
      }).then(settle, settle);

      function settle() {
        delete busyLines[token];
        cartPending--;
        if (cartPending > 0 || !cartBurst) return;
        /* Last one home after a burst: whatever the interim renders showed,
           this is the cart. */
        cartBurst = false;
        return refresh();
      }
    });

    /* The only way into this closure from another file. The product page runs
       from redesign-pdp.js and needs to add a line and have the drawer
       re-render and open — everything it would need to do that (the section id,
       the money snapshot, applySection) lives in here and should stay here.

       One round trip: cart/add.js returns the re-rendered drawer alongside the
       cart, so there is no follow-up fetch to render what was just added. */
    /* Point the engine at another surface (the cart page). Returns the tuned
       pipeline — same tween, same collapse, same entering animation — so there
       is exactly one implementation of "update a cart without a reload". */
    function retarget(opts) {
      ROOT = opts.root;
      if (opts.sel) Object.keys(opts.sel).forEach(function (k) { SEL[k] = opts.sel[k]; });
      if (opts.sectionId) SECTION_ID = opts.sectionId;
      return {
        snapshot: snapshotMoney,
        applyOptimistic: applyOptimistic,
        collapseLine: collapseLine,
        markNewLines: markNewLines,
        animateMoneyFrom: animateMoneyFrom,
        sectionFromCartResponse: sectionFromCartResponse,
        sectionId: function () { return SECTION_ID; }
      };
    }

    /* ---- starter packs: one of each per order -------------------------
       The x+1 starters are a trial offer, one per order (Sam, 21 Sep 2026).
       Hiding the stepper was only half of it: Shopify merges a second add of
       the same variant into one line of two, and an add of {quantity: 3} is
       accepted outright — both verified against the live cart. In the 100
       starter orders to 22 Sep, six had a starter line at 2, 3 or 4.

       The rows say which they are: snippets/redesign-cart-drawer.liquid and
       sections/cart-template.liquid put data-rd-starter="<quantity>" on a
       line whose SKU ends in -starter, so this works on either surface from
       the markup the server already sent.

       Two moves. A second add of a starter already in the cart is refused
       before it goes; and a starter line found at more than one — from a
       double add that raced this, an older cart, or anything that talked to
       /cart/add.js directly — is put back to one. Both say why.

       It is not airtight and cannot be: the Shop app, Meta, Google, TikTok
       and Pinterest all check out without ever running this file. That is
       what the checkout validation function is for; see
       docs/STARTER-LIMIT.md. */
    function starterRows() {
      return [].slice.call(document.querySelectorAll('[data-rd-starter][data-rd-key]'));
    }

    function starterInCart(id) {
      id = String(id);
      return starterRows().some(function (row) {
        return (row.getAttribute('data-rd-key') || '').split(':')[0] === id;
      });
    }

    var starterNoticeUntil = 0;

    function paintStarterNote() {
      var on = Date.now() < starterNoticeUntil;
      [].slice.call(document.querySelectorAll('[data-rd-starter-note]')).forEach(function (note) {
        note.hidden = !on;
      });
    }

    function flagStarterLimit() {
      starterNoticeUntil = Date.now() + 9000;
      paintStarterNote();
    }

    /* Each line is only ever capped ONCE per page load. Without that, a change
       that came back still showing two — a stale section, a cart the server
       disagrees about — would post again on the re-render it caused, and again,
       for as long as the page was open. One attempt, then leave it alone and
       let the checkout validation catch what the browser could not. */
    var capTried = Object.create(null);

    function starterOver() {
      var over = null;
      starterRows().some(function (row) {
        var key = row.getAttribute('data-rd-key');
        if (capTried[key]) return false;
        if ((parseInt(row.getAttribute('data-rd-starter'), 10) || 1) > 1) { over = row; return true; }
        return false;
      });
      if (over) capTried[over.getAttribute('data-rd-key')] = true;
      return over;
    }

    /* One line per pass: the change re-renders, which runs this again, so a
       cart holding several over-quantity starters unwinds one at a time and
       stops when there are none left.

       The CART PAGE has its own applySection and its own post (see
       assets/redesign-cart.js) — it runs the same rule through those, so this
       one stands aside where that page is on screen. */
    function capStarters() {
      if (document.querySelector('.rd-cartp')) return;
      var over = starterOver();
      if (!over) return;

      var snap = snapshotMoney();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: over.getAttribute('data-rd-key'), quantity: 1, sections: SECTION_ID })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart/change.js ' + r.status);
        return r.json();
      }).then(function (data) {
        flagStarterLimit();
        var html = sectionFromCartResponse(data);
        if (html) applySection(html, snap, data); else refresh(snap);
      }).catch(function (err) {
        console.error('Starter cap failed:', err);
      });
    }

    /* The add itself, re-rendering whichever surface the engine points at —
       and nothing else, so the lost-add guard can repair through it without
       opening the drawer or starting a second watch of its own. */
    /* The guard hands back the lines to restore, as an array. */
    function readdLines(items) { return addAndRender({ items: items }); }

    function addAndRender(payload) {
      var snap = snapshotMoney();
      payload.sections = SECTION_ID;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (r.ok) return r.json();
        /* Shopify puts the useful part — "You can only add N to the cart" —
           in the body, so surface that rather than a bare status code. */
        return r.json().then(function (e) {
          throw new Error(e.description || e.message || 'cart/add.js ' + r.status);
        }, function () { throw new Error('cart/add.js ' + r.status); });
      }).then(function (data) {
        var html = sectionFromCartResponse(data);
        if (html) applySection(html, snap, data); else refresh(snap);
        return data;
      });
    }

    window.rdCart = {
      open: open,
      retarget: retarget,
      /* The cart PAGE reuses these rather than carrying a third copy of the
         money shape — snippets/redesign-money.liquid and moneyHTML above are
         already a pair that has to stay in step, and a third would rot. */
      /* The cart page enforces the same starter rule through its own render
         path, with these. */
      starters: {
        over: starterOver,
        inCart: starterInCart,
        flag: flagStarterLimit,
        paint: paintStarterNote
      },
      money: money,
      moneyHTML: moneyHTML,
      tweenMoney: tweenMoney,
      readCents: readCents,
      starterCap: capStarters,
      add: function (payload) {
        /* Already holding this starter: open the cart and say so rather than
           adding a second one Shopify would merge into a line of two. */
        if (payload && payload.id && starterInCart(payload.id)) {
          open();
          flagStarterLimit();
          return Promise.resolve(null);
        }
        return addAndRender(payload).then(function (data) {
          open();
          window.rdCartGuard.watch(data, readdLines);
          return data;
        });
      }
    };

    /* A cart that arrived over the limit is put right on arrival, whichever
       page the drawer is sitting on. */
    capStarters();
  })();

  /* ------------------------------------------------------------- modals */
  /* Any .rd-modal[data-rd-modal]. Two kinds of opener: [data-rd-warehouse-open]
     for the daily photo (kept as-is — it is wired from several places) and
     [data-rd-modal-open="<id>"] for anything else, first used by the article's
     Fact Checked promise, which was Bootstrap's modal until 2 Sep 2026. One
     modal open at a time; [data-rd-close] inside the open one closes it. */
  (function () {
    if (!document.querySelector('.rd-modal[data-rd-modal], [data-rd-warehouse]')) return;
    var current = null, lastFocus = null;

    function openModal(modal, trigger) {
      if (current && current !== modal) closeModal(current, true);
      current = modal;
      lastFocus = trigger || document.activeElement;
      modal.hidden = false;
      document.body.classList.add('rd-modal-open');
      var close = modal.querySelector('.rd-modal__close');
      if (close) close.focus();
    }

    /* Fade out before hiding — [hidden] on its own removes the popup instantly.
       animationend does the hide, with a timeout fallback for reduced-motion and
       background tabs. */
    function closeModal(modal, instant) {
      if (!modal || modal.hidden || modal.classList.contains('is-closing')) return;
      modal.classList.add('is-closing');
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        modal.classList.remove('is-closing');
        modal.hidden = true;
        if (current === modal) current = null;
        if (!document.querySelector('.rd-modal:not([hidden])')) document.body.classList.remove('rd-modal-open');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      if (instant) { finish(); return; }
      /* Wait on the SCRIM, not the panel. The softened close deliberately lets
         the scrim trail the panel, so hiding on the panel's animationend would
         cut the backdrop's fade off partway. Fallback covers the scrim's full
         delay plus duration. */
      rdExit([
        { el: modal.querySelector('.rd-modal__panel') },
        { el: modal.querySelector('.rd-modal__scrim') }
      ], 620, finish);
    }

    document.addEventListener('click', function (e) {
      var wh = e.target.closest('[data-rd-warehouse-open]');
      if (wh) {
        var m = document.querySelector('[data-rd-warehouse]');
        if (m) { e.preventDefault(); openModal(m, wh); }
        return;
      }
      var op = e.target.closest('[data-rd-modal-open]');
      if (op) {
        var t = document.getElementById(op.getAttribute('data-rd-modal-open'));
        if (t) { e.preventDefault(); openModal(t, op); }
        return;
      }
      var cl = e.target.closest('[data-rd-close]');
      if (cl && current && current.contains(cl)) closeModal(current);
    });

    document.addEventListener('keydown', function (e) {
      if (!current) return;
      if (e.key === 'Escape') { closeModal(current); return; }
      /* Keep tab focus inside the dialog while it is open. */
      if (e.key === 'Tab') {
        var f = current.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  })();

  /* ------------------------------------------------------------- accordion
     Height is animated (Web Animations API), and when a question opens while
     another is open the two run together on one curve, so the page grows or
     shrinks once, by the difference — it used to drop the new answer in at
     full height at once and fade the old one out for 300ms before hiding it,
     which moved everything below twice (Sam, 7 Sep 2026, on the PDP).
     [hidden] stays the source of truth for no-JS and assistive tech; the
     animation only decides when it lands. Reduced motion keeps the old
     instant toggle. */
  (function () {
    var DUR = 380;
    var EASE = 'cubic-bezier(.45, 0, .2, 1)';
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function stop(b) {
      if (b.getAnimations) b.getAnimations().forEach(function (a) { a.cancel(); });
    }

    function collapse(b, t) {
      if (b.hidden) return;
      t.setAttribute('aria-expanded', 'false');
      if (reduced || !b.animate) { stop(b); b.hidden = true; return; }
      var from = b.getBoundingClientRect().height;   /* wherever it is right now */
      stop(b);
      var pad = getComputedStyle(b).paddingBottom;
      b.style.overflow = 'hidden';
      var anim = b.animate(
        [{ height: from + 'px', paddingBottom: pad, opacity: 1 },
         { height: '0px', paddingBottom: '0px', opacity: 0 }],
        { duration: DUR, easing: EASE, fill: 'forwards' });
      anim.onfinish = function () {
        b.hidden = true;
        b.style.overflow = '';
        anim.cancel();   /* drop the fill so the next open measures the real height */
      };
    }

    function expand(b, t) {
      t.setAttribute('aria-expanded', 'true');
      if (reduced || !b.animate) { stop(b); b.hidden = false; return; }
      var from = b.hidden ? 0 : b.getBoundingClientRect().height;
      stop(b);
      b.hidden = false;
      var to = b.getBoundingClientRect().height;      /* natural height, nothing inline */
      var pad = getComputedStyle(b).paddingBottom;
      b.style.overflow = 'hidden';
      var anim = b.animate(
        [{ height: from + 'px', paddingBottom: from ? pad : '0px', opacity: from ? 1 : 0 },
         { height: to + 'px', paddingBottom: pad, opacity: 1 }],
        { duration: DUR, easing: EASE });
      anim.onfinish = function () { b.style.overflow = ''; };
    }

    document.querySelectorAll('[data-rd-accordion]').forEach(function (acc) {
      acc.addEventListener('click', function (e) {
        var btn = e.target.closest('.rd-faq__btn');
        if (!btn || !acc.contains(btn)) return;
        var body = document.getElementById(btn.getAttribute('aria-controls'));
        if (!body) return;
        if (btn.getAttribute('aria-expanded') === 'true') { collapse(body, btn); return; }
        /* Same task, same curve: the old answer shrinks while the new one grows. */
        acc.querySelectorAll('.rd-faq__btn[aria-expanded="true"]').forEach(function (other) {
          var ob = document.getElementById(other.getAttribute('aria-controls'));
          if (ob && ob !== body) collapse(ob, other);
        });
        expand(body, btn);
      });
    });
  })();

  /* ------------------------------------------------- currency selector ----
     The footer's country/currency control, snippets/rd-localization.liquid
     (docs/MULTI-CURRENCY.md §4.4). The markup is a real localization form whose
     rows are submit buttons, so it works with JavaScript off — the rows then
     sit in the footer as a plain list. This only turns them into a dropdown:
     the button toggles it, Escape or a click elsewhere closes it (Escape hands
     focus back to the button), the arrow keys, Home and End move between rows,
     and aria-expanded follows. Choosing a row submits the form; Shopify sets
     the localization cookie and the page reloads in the new currency. No
     fetch.

     The list is absolutely positioned (redesign.css), so opening it moves
     nothing on the page. It drops down, and opens upward instead when there
     is no room below it in the viewport. */
  (function () {
    var box = document.querySelector('[data-rd-loc]');
    if (!box) return;
    var btn = box.querySelector('[data-rd-loc-btn]');
    var list = box.querySelector('[data-rd-loc-list]');
    if (!btn || !list) return;
    var opts = Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));
    if (!opts.length) return;

    function chosen() {
      return opts.filter(function (o) { return o.getAttribute('aria-selected') === 'true'; })[0] || opts[0];
    }
    /* Roving tabindex: one row in the tab order at a time, so Tab leaves the
       list rather than walking every row. */
    function focusRow(o) {
      opts.forEach(function (x) { x.tabIndex = x === o ? 0 : -1; });
      if (o) o.focus();
    }
    function open(last) {
      if (!list.hidden) return;
      list.classList.remove('is-up');
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      /* Measured in the same task that unhides it, before the frame is
         painted, so flipping it upward is never seen. */
      var r = list.getBoundingClientRect();
      if (r.bottom > window.innerHeight && btn.getBoundingClientRect().top > r.height + 8) {
        list.classList.add('is-up');
      }
      focusRow(last ? opts[opts.length - 1] : chosen());
    }
    function close(refocus) {
      if (list.hidden) return;
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      if (refocus) btn.focus();
    }

    btn.addEventListener('click', function () {
      if (list.hidden) open(false); else close(true);
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        open(e.key === 'ArrowUp');
      }
    });
    list.addEventListener('keydown', function (e) {
      var i = opts.indexOf(document.activeElement), next = null;
      if (e.key === 'ArrowDown') next = opts[Math.min(opts.length - 1, i + 1)];
      else if (e.key === 'ArrowUp') next = opts[Math.max(0, i - 1)];
      else if (e.key === 'Home') next = opts[0];
      else if (e.key === 'End') next = opts[opts.length - 1];
      if (next) { e.preventDefault(); focusRow(next); }
    });
    /* The row already in force changes nothing, so it closes the list
       instead of reloading the page to arrive where it already is. */
    list.addEventListener('click', function (e) {
      var o = e.target.closest('[role="option"]');
      if (o && o.getAttribute('aria-selected') === 'true') { e.preventDefault(); close(true); }
    });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !list.hidden) { e.preventDefault(); close(true); }
    });
    document.addEventListener('click', function (e) {
      if (!list.hidden && !box.contains(e.target)) close(false);
    });
    box.addEventListener('focusout', function (e) {
      if (!list.hidden && e.relatedTarget && !box.contains(e.relatedTarget)) close(false);
    });
  })();
})();
